module.exports = __webpack_public_path__ + "static/media/icon-piece-loa-06.90e8dbf4.png";